/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderPaymentType {
    DEPOSIT = 'Deposit',
    HOLD = 'Hold',
    CAPTURE = 'Capture',
    PAYMENT = 'Payment',
    REFUND = 'Refund',
}
